import React from "react";
import { FaChair, FaTable, FaCouch } from "react-icons/fa";
import woodenBanner from "../assets/banner4.jpg";

export default function WoodenFurniture() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">
        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Custom Wooden Furniture
          </h2>
          <p className="text-muted fs-6">
            Unique, high-quality wooden furniture tailored to your space and style.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={woodenBanner}
            alt="Wooden Furniture"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ designs and creates a variety of custom wooden furniture. Each piece is crafted to fit your space and style preferences, using a blend of traditional woodworking and modern technology to ensure durability and elegance.
          </p>

          {/* KEY FURNITURE TYPES */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaTable size={22} className="me-3 text-primary" />
              <span>Dining Tables: Custom sizes and finishes to suit any dining space.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaChair size={22} className="me-3 text-primary" />
              <span>Chairs: Comfortable, stylish, and made with durable wood.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCouch size={22} className="me-3 text-primary" />
              <span>Shelving Units & Entertainment Centers: Functional and elegant storage solutions.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCouch size={22} className="me-3 text-primary" />
              <span>Other Custom Wooden Pieces: Crafted according to your design needs.</span>
            </li>
          </ul>

          {/* WORKFLOW / PROCESS */}
          <ol className="fs-6 mb-3">
            <li>Consultation to understand your design and functional requirements.</li>
            <li>Custom design and material selection tailored to your space.</li>
            <li>Skilled craftsmanship ensures durable, high-quality furniture.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Every piece of wooden furniture is designed to enhance your home or office with elegance, functionality, and longevity.
          </p>
        </div>
      </div>
    </div>
  );
}
